import { Component } from '@angular/core';

@Component({
  selector: 'app-portfolio-project2',
  standalone: true,
  imports: [],
  templateUrl: './portfolio-project2.component.html',
  styleUrl: './portfolio-project2.component.scss'
})
export class PortfolioProject2Component {

}
